
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"186","height":"180","viewBox":"0 0 186 180","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M113.994 2.27419C141.499 9.25259 162.423 30.5666 174.124 56.4188C186.099 82.8767 190.303 113.951 175.97 139.209C161.996 163.836 133.124 173.612 105.147 177.976C78.4124 182.145 50.3491 179.465 29.6589 162.028C8.65315 144.325 -1.29063 116.907 0.133965 89.4737C1.53801 62.4357 15.4554 38.0782 36.9503 21.6163C59.067 4.67828 86.992 -4.57653 113.994 2.27419Z","fill":"#FFB088"}})])
          )
        }
      }
    